import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Chip} from "@mui/material";

import {green50, green600, greyishBlue600} from "assets/jss/main";

import {formatDate, formatMoney} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

ProductsSentCard.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    accountLinked: PropTypes.bool.isRequired,
};

/**
 * Every card the assistant sent, whether the shopper clicked it and whether it was bought
 * (known only when the shopper's account is linked).
 */
function ProductsSentCard({products, accountLinked}) {
    return (
        <SideCard titleId="personalShopper.products.title">
            {products.length === 0 && (
                <div style={{color: greyishBlue600, fontSize: "13px"}}><FormattedMessage id="personalShopper.products.empty" /></div>
            )}
            {products.map((product, index) => (
                <div key={`${product.code}-${index}`} style={{display: "flex", gap: "10px", alignItems: "center", padding: "6px 0", borderTop: index > 0 ? "1px solid #E6E7EB" : "none", fontSize: "13px"}}>
                    {product.imageUrl
                        ? <img src={product.imageUrl} alt="" style={{width: "40px", height: "40px", objectFit: "cover", borderRadius: "6px"}} />
                        : <div style={{width: "40px", height: "40px", borderRadius: "6px", backgroundColor: "#F4F4F6"}} />}
                    <div style={{flex: 1, minWidth: 0}}>
                        <div style={{fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                            {product.brand ? `${product.brand} · ` : ""}{product.name}
                        </div>
                        <div style={{color: greyishBlue600, fontSize: "12px"}}>
                            {formatDate(product.sentAt)}{product.price !== null && product.price !== undefined ? ` · ${formatMoney(product.price)}` : ""}
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-end"}}>
                        <Chip size="small" label={product.clicks > 0 ? <FormattedMessage id="personalShopper.products.clicked" values={{count: product.clicks}} /> : <FormattedMessage id="personalShopper.products.notClicked" />} sx={product.clicks > 0 ? {backgroundColor: green50, color: green600} : {}} />
                        {product.purchased
                            ? <Chip size="small" label={<FormattedMessage id="personalShopper.products.purchased" values={{order: product.orderNumber}} />} sx={{backgroundColor: green50, color: green600}} />
                            : <span style={{color: greyishBlue600, fontSize: "11px"}}><FormattedMessage id={accountLinked ? "personalShopper.products.notPurchased" : "personalShopper.products.unknown"} /></span>}
                    </div>
                </div>
            ))}
        </SideCard>
    );
}

export default ProductsSentCard;
